import api from '../api';

export default {
  namespaced: true,
  state: {
    userInfo: {},
    menus: null,
    permissions: {
      // 权限
      osm_audit_waning_exception: false, // OSM-审计系统-报警与异常
      osm_audit_take_dou: false, // OSM-审计系统-提豆审核
      osm_audit_take_dou_complete: false, // OSM-审计系统-完全提豆检查
      osm_time_limit_no: false, // OSM-查询数据无时间限制
      osm_all_field: false, // OSM-信息全字段
      osm_room_info_export: false, // OSM-牌局信息导出
      osm_at_super_distribution: false, // AT分发全信息显示
    },
  },

  actions: {
    // 获取谷歌验证码绑定状态
    getBindStatus(store, params) {
      return api.post('/authUsers/getUserInfo', '获取谷歌验证码绑定状态', params).then((res) => {
        return res;
      });
    },
    // 获取随机谷歌验证码
    getGoogleCode() {
      return api.get('/google/authenticator/generate', '获取随机谷歌验证码').then((res) => {
        return res;
      });
    },
    // 绑定谷歌验证码
    bindGoogleCode(store, params) {
      return api.post('/google/authenticator/bind', '绑定谷歌验证码', params).then((res) => {
        return res;
      });
    },
  },
};
